import React from "react";
import { DataProps } from "types";
import { MemoItem, AlertItem } from "components";
import { View, Text } from "ui";
import { groupByExpirationStatus, groupByMonth } from "pages/alertList/util";
import { styled } from "styles";
import _ from "lodash";
import moment from "moment";
import { DATE_FORMAT } from 'shared/constants';


export default class Alerts extends React.Component<DataProps> {
  public render() {
    const { memos } = this.props;
    const memosHash = _.reduce(
      memos,
      (acc, memo) => ({
        ...acc,
        [memo.id]: memo
      }),
      {}
    );
    const alerts = this.props.alerts.filter(a => !!memosHash[a.memo_id]);

    const { expired, active } = groupByExpirationStatus(alerts);
    const monthExpired = groupByMonth(expired);
    const monthActive = groupByMonth(active);
    const hasExpired = Object.keys(monthExpired).length > 0;
    const hasActive = Object.keys(monthActive).length > 0;

    return (
      <View flexDirection="column">
        {!hasExpired &&
          !hasActive && (
            <View>
              <Text>Nu exista alerte</Text>
            </View>
          )}
        {hasExpired && (
          <React.Fragment>
            <Text mb={2} fontSize={4} fontWeight="bold">
              Alerte Expirate
            </Text>
            {_.map(monthExpired, (monthAlerts, month) => {
              return (
                <React.Fragment key={month}>
                  <Text mt={2} fontSize={2} color="primary">
                    {month}
                  </Text>
                  {_.orderBy(monthAlerts, a => moment(a.end_date, DATE_FORMAT)).map(alert => (
                      <AlertItem
                        key={alert.id}
                        alert={alert}
                        expired={true}
                        memo={memosHash[alert.memo_id]}
                      />
                  ))}
                </React.Fragment>
              );
            })}
          </React.Fragment>
        )}
        {hasActive && (
          <React.Fragment>
            <Text fontSize={4} mb={2} mt={2} fontWeight="bold">Alerte Active</Text>
            {_.map(monthActive, (monthAlerts, month) => {
              return (
                <React.Fragment key={month}>
                  <Text mt={2} fontSize={2} color="primary">
                    {month}
                  </Text>
                  {_.orderBy(monthAlerts, a => moment(a.end_date, DATE_FORMAT)).map(alert => (
                    <AlertItem
                      key={alert.id}
                      alert={alert}
                      expired={false}
                      memo={memosHash[alert.memo_id]}
                    />
                  ))}
                </React.Fragment>
              );
            })}
          </React.Fragment>
        )}
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/main/Alerts.tsx